import React, { useState } from 'react';
import { apiPost } from '../utils/api';

const MathEvaluator = () => {
  const [expression, setExpression] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleEvaluate = async () => {
    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/utils/math-eval', { expression });
      setResult(data.result);
    } catch (e) {
      setResult('Erro ao calcular.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Calculadora Avançada</h2>
      <p className="mb-4 text-gray-600">Digite uma expressão matemática para avaliar. Exemplo: <code className="bg-gray-100 px-1 rounded">(2+3)*4/5</code></p>
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={expression}
          onChange={e => setExpression(e.target.value)}
          placeholder="Ex: (2+3)*4/5"
          className="flex-1 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={handleEvaluate}
          disabled={loading || !expression.trim()}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? 'Calculando...' : 'Calcular'}
        </button>
      </div>
      {result !== null && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg text-lg text-center font-mono text-gray-800">
          Resultado: {result}
        </div>
      )}
    </div>
  );
};

export default MathEvaluator; 